import { call } from 'redux-saga/effects';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { LensCard } from '~src/lens/components/cardView/LensCard';
import { Lenses } from '~src/lens/resources/Lenses';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ContentTypeFilterClause,MixedContentItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { LensContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getLensInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const LensDefinition: MixedContentItemDefinition & SpaceDefinition<'lens'> = {
  itemType: 'lens',
  contentType: 'lens',
  singularName: Messages.lens,
  pluralName: Messages.lenses,
  emptyStateMessage: Messages.lensesEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Lenses,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.lensUrl(contentId),
  contentFilterKeys: LensContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: LensCard,
  listViewIconUrl: imgPath('spaces_small_lens.svg'),
  filterClause: ServerFilterClauses.ContentType(['lens']) as ContentTypeFilterClause,
  getBasicQuery: () => Lenses.all(),
  fieldValueResourceType: 'lens',
  getContentInfo: (contentList: IContentInfo[]) => call(getLensInfos, contentList),
  supportedDisplayModes: ['list', 'thumbnail'],
  headerIconPath: () => imgPath('spaces_masthead_lens.svg'),
};
